import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { shouldTrackMetaPixel, trackMetaPageView } from "@/analytics/metaPixel";

/**
 * SPA route changes: index.html already fires the first PageView on load.
 */
export default function MetaPixel() {
  const { pathname } = useLocation();
  const skipNextPageView = useRef(true);

  useEffect(() => {
    if (!shouldTrackMetaPixel(pathname)) return;

    if (skipNextPageView.current) {
      skipNextPageView.current = false;
      return;
    }

    trackMetaPageView();
  }, [pathname]);

  return null;
}
